/* eslint-disable i18next/no-literal-string */
import React, { useState } from 'react';
import { makeStyles } from '@fluentui/react';
import clsx from 'clsx';
import { useAppSelector } from 'store';

import { PerformanceDialog } from './PerformanceDialog';

import './PerformanceBar.scss';

const PerformanceBar: React.FunctionComponent = () => {
  const perf = useAppSelector((state) => state.performance!);
  const preRequestDuration = perf.preRequestTime || 0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let details = null;

  if (perf.serverTime) {
    const clientTime = perf.pageLoadTime - perf.serverTime - preRequestDuration;

    details = `(Pre-Req: ${preRequestDuration}ms, Server: ${perf.serverTime}ms, Client: ${clientTime}ms)`;
  }

  const styles = makeStyles((theme) => ({
    themeColors: {
      color: theme!.palette.white,
      backgroundColor: theme!.palette.neutralPrimary,
    },
    perfBar: {
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100%',
      zIndex: 3,
      padding: '3px 0px',
      fontSize: '1.2rem',
      textAlign: 'right',
    },
    perfSection: {
      padding: '0px 10px',
      '&.clickable': {
        cursor: 'pointer',
        '&: hover': {
          backgroundColor: 'darkgray',
        },
      },
    },
  }));

  const handleDismissClick = (): void => setIsDialogOpen(false);
  const handleClick = (): void => setIsDialogOpen(!isDialogOpen);
  const handleKeyDown = (event: React.KeyboardEvent): void => {
    const key = event?.nativeEvent?.code;

    if (['Enter', 'Space'].includes(key)) {
      setIsDialogOpen(true);
    } else if (key === 'Escape') {
      setIsDialogOpen(false);
    }
  };

  return (
    <>
      <div className={clsx(styles().themeColors, styles().perfBar)}>
        {/* NOTE: buttonized non-button: https://stackoverflow.com/a/50731217/226756 */}
        {/* workaround for jsx-a11y/click-events-have-key-events */}
        <div
          role="button"
          className={clsx(styles().perfSection, 'clickable')}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          Performance TTI {perf.pageLoadTime}ms {details}
        </div>
      </div>
      {isDialogOpen && <PerformanceDialog isOpen={isDialogOpen} performanceData={perf} onDismiss={handleDismissClick} />}
    </>
  );
};

export default PerformanceBar;
